// sub-components
import { Accordion, Modal, TabLayout } from "../../../components/ui";

import SpendingAverages from "../spending/SpendingAverages";
import Ledger from "../spending/Ledger";
import Accounts from "../accounts/Accounts";

const LavellaDashboard = () => {
	return (
		<div className="lavella page dashboard dark-mode-disabled">
			<section>
				<div className="cont--lg">
					<p className="eyebrow">Lavella Life</p>
					<h1 className="title3">Dashboard</h1>
				</div>
				<div className="cont--lg">
					<TabLayout
						container="tab-section lavella-life"
						tabs={[
							{
								title: "Summary",
								content: <h4>Summary</h4>,
							},
							{
								title: "Spending Averages",
								content: <SpendingAverages />,
							},
							{
								title: "Accounts",
								content: <Accounts />,
							},
							{
								title: "Ledger",
								content: <Ledger />,
							},
							{
								title: "Forecasting",
								content: <h4>Forecasting</h4>,
							},
						]}></TabLayout>
				</div>
			</section>
		</div>
	);
};

export default LavellaDashboard;
